import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BalanceService } from 'src/app/services/balance.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

declare var SecureCheckout;

@Component({
  selector: 'app-cybersource',
  templateUrl: './cybersource.component.html',
  styleUrls: ['./cybersource.component.scss'],
})
export class CybersourceComponent implements OnInit {
  @Input() amount: number;
  @Input() orderId: number;
  @Output() finish$ = new EventEmitter();

  creditAndDebitPaymentMethodList = [
    {
      name: 'Visa',
      value: 'visa',
    },
    {
      name: 'Mastercard',
      value: 'mastercard',
    },
    {
      name: 'American Express',
      value: 'amex',
    },
    {
      name: 'Discover',
      value: 'discover',
    },
    {
      name: 'Diners Club',
      value: 'diners',
    },
    {
      name: 'JCB',
      value: 'jcb',
    },
    {
      name: 'UnionPay',
      value: 'unionpay',
    },
    {
      name: 'RuPay',
      value: 'rupay',
    },
    {
      name: 'ELO',
      value: 'elo',
    },
    {
      name: 'Hipercard',
      value: 'hipercard',
    },
    {
      name: 'Cartes Bancaires',
      value: 'cartesbancaires',
    },
    {
      name: 'Mada',
      value: 'mada',
    },
    {
      name: 'Aura',
      value: 'Aura',
    },
  ];

  digitalWallets = [
    {
      name: 'Apple Pay',
      value: 'applepay',
    },
    {
      name: 'Google Pay',
      value: 'googlepay',
    },
    {
      name: 'Samsung Pay',
      value: 'samsungpay',
    },
    {
      name: 'Visa Checkout',
      value: 'visacheckout',
    },
    {
      name: 'Masterpass',
      value: 'masterpass',
    },
  ];

  transferences = [
    {
      name: 'iDEAL',
      value: 'ideal',
    },
    {
      name: 'Bancontact',
      value: 'bancontact',
    },
    {
      name: 'SEPA Direct Debit',
      value: 'sepa',
    },
    {
      name: 'ACH',
      value: 'ach',
    },
    {
      name: 'Boleto Bancário',
      value: 'boletobancario',
    },
  ];

  others = [
    {
      name: 'PayPal',
      value: 'paypal',
    },
    {
      name: 'Klarna',
      value: 'klarna',
    },
    {
      name: 'Afterpay',
      value: 'afterpay',
    },
    {
      name: 'Alipay',
      value: 'alipay',
    },
    {
      name: 'WeChat Pay',
      value: 'wechatpay',
    },
  ];
  jwt = '';
  loaded = false;
  listening = false;
  selected = this.creditAndDebitPaymentMethodList;
  public formGroup: FormGroup;

  constructor(
    private httpSv: HttpService,
    private fb: FormBuilder,
    private balanceSv: BalanceService,
    private uiSv: UiServices
  ) {}

  ngOnInit() {
    this.formGroup = this.fb.group({
      expirationMonth: ['', Validators.required],
      expirationYear: ['', Validators.required],
      number: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
    });
    const script = document.createElement('script');
    // script.onload = () => {
    //   pfWallet.useAsSandbox(true);
    // };
    script.src = 'https://testsecureacceptance.cybersource.com/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  }

  segmentChanged(ev: Event) {
    const event = ev.target as HTMLIonSegmentElement;
    if (event.value === 'card') {
      this.selected = this.creditAndDebitPaymentMethodList;
      return;
    }
    if (event.value === 'wallet') {
      this.selected = this.digitalWallets;
      return;
    }
    if (event.value === 'transference') {
      this.selected = this.transferences;
      return;
    }
    if (event.value === 'other') {
      this.selected = this.others;
      return;
    }
  }

  getPayment() {
    this.finish$.emit('yappy');
  }

  async getMerchant(ev: Event) {
    try {
      const event = ev.target as HTMLIonSelectElement;
      const paymentData = {
        amount: this.amount * 100, // Convierte $10.00 a 1000 centavos
        currency: 'USD',
        paymentMethod: event.value,
      };

      await this.httpSv.itemAction(
        paymentData,
        'purchase/cybersource',
        'generated'
      );
    } catch (error) {
      console.error(error);
    }
  }

  initiateCheckout(paymentData: any) {
    SecureCheckout.configure({
      merchantID: 'your_merchant_id',
      orderPage_transactionType: 'sale',
      orderPage_signaturePublic: paymentData.signature,
      orderPage_timestamp: paymentData.timestamp,
      orderPage_version: '1',
      orderPage_merchantData1: paymentData.merchantData1,
      // Añade otros datos necesarios aquí
    });
    SecureCheckout.start();
  }

  async handleSubmit(ev: Event) {
    try {
      ev.preventDefault();
      const obj = {
        amount: this.amount,
        type: 'bancoGeneral',
        currency:
          this.balanceSv.currency?.symbol || this.balanceSv.currencyBaseName,
        orderId: this.orderId,
        discount: 0,
        domainId: environment.domainId,
      };

      const body = {
        clientReferenceInformation: {
          code: Math.round(Math.random() * 10000),
        },
        paymentInformation: {
          card: {
            number: this.formGroup.value.number,
            expirationMonth: this.formGroup.value.expirationMonth,
            expirationYear: this.formGroup.value.expirationYear,
          },
        },
        orderInformation: {
          amountDetails: {
            totalAmount: this.amount,
            currency:
              this.balanceSv.currency?.symbol ||
              this.balanceSv.currencyBaseName,
          },
          billTo: {
            firstName: this.formGroup.value.firstName,
            lastName: this.formGroup.value.lastName,
          },
        },
        merchantInformation: {
          returnUrl: `${environment.webSiteUrl}/home?successPaym=1&ori=${btoa(
            JSON.stringify(obj)
          )}`,
          failureUrl: `${environment.webSiteUrl}/home?successPaym=0`,
        },
      };
      const res = await this.httpSv.itemAction(
        body,
        'purchase/cybersource',
        'generatedStepOne'
      );
      this.jwt = res.data.consumerAuthenticationInformation.accessToken;
      setTimeout(() => {
        var cardinalCollectionForm = document.querySelector(
          '#cardinal_collection_form'
        ) as HTMLFormElement;
        if (cardinalCollectionForm) {
          // form exists
          cardinalCollectionForm.submit();
        }

        if (!this.listening) {
          this.listening = true;
          window.addEventListener(
            'message',
            async (event) => {
              if (event.origin === environment.bg_general) {
                const payload = JSON.parse(event.data);
                if (
                  payload.MessageType === 'profile.completed' &&
                  payload.Status
                ) {
                  const res = await this.httpSv.itemAction(
                    {
                      code: body.clientReferenceInformation.code,
                      currency: body.orderInformation.amountDetails.currency,
                      totalAmount:
                        body.orderInformation.amountDetails.totalAmount,
                      firstName: body.orderInformation.billTo.firstName,
                      lastName: body.orderInformation.billTo.lastName,
                      number: this.formGroup.value.number,
                      expirationMonth: this.formGroup.value.expirationMonth,
                      expirationYear: this.formGroup.value.expirationYear,
                    },
                    'purchase/cybersource',
                    'stepThree'
                  );
                  if (
                    res.consumerAuthenticationInformation.veresEnrolled === 'U'
                  ) {
                    this.uiSv.presentAlert(
                      'No hemos podido procesar el pago. Por favor selecciona otro metodo de pago para continuar.'
                    );
                    return;
                  }
                  this.loaded = true;
                  setTimeout(() => {
                    const stepUpForm: any =
                      document.querySelector('#step-up-form');
                    if (stepUpForm) {
                      // Step-Up form exists
                      stepUpForm.submit();
                    }
                  });
                }
              }
            },
            false
          );
        }
      });
    } catch (error) {
      console.error(error);
    }
  }
}
